<div class="mb-5">
	<h1 class="h3 m-4">{{'utilization.truck_utilization_score' | translate}} <app-help-tooltip [field]="'utilization_scores'"></app-help-tooltip></h1>
	<div class="chart-container">
		<div class="charts-row" *ngIf="showData; else noData">
			<app-truck-utilization-charts
				[title]="'utilization.percent_utilization_score'| translate"
				[devices]="filteredDevices"
				[data]="utilizationScoreSelectedData"
				[deviceType]="truckDeviceType"
				[selectedPeriod]="selectedPeriod"
			>
			</app-truck-utilization-charts>
			<app-truck-utilization-charts
				[title]="'utilization.percent_energy_usage_score'| translate"
				[devices]="filteredDevices"
				[data]="energyScoreSelectedData"
				[deviceType]="truckDeviceType"
				[toDrawValue]="'energy_score'"
				[selectedPeriod]="selectedPeriod"
			>
			</app-truck-utilization-charts>
		</div>
	</div>
</div>
<ng-template #noData>
	<div class="mt-4">
		<div class="alert alert-info pl-4 pr-4">
		{{ 'g.no_data_to_show' | translate }}
		</div>
	</div>
</ng-template>
